import { useQuery } from '@tanstack/react-query'
import { ytjCompanySearch } from '../integrations/ytj'
import { getApiErrorMessage } from '@utils'
import { useTranslation } from 'react-i18next'

export const useYTJSearch = (searchTerm: string | undefined, enabled = true) => {
  const [t] = useTranslation()

  const query = useQuery({
    queryKey: ['ytj', 'search', searchTerm?.toLowerCase()],
    queryFn: () => ytjCompanySearch({ searchTerm: searchTerm?.toLowerCase() }),
    enabled: enabled && searchTerm?.length >= 3,
    retry: 1,
    staleTime: 1000 * 60 * 60 // 60 mins,
  })

  const errorMessage = getApiErrorMessage(query.error, t('general.error'))

  return { query, errorMessage }
}
